import { post } from '@http/request'
/**
 * 订单状态量统计
 *
 * @param {*} params
 * @returns
 */
export const reqStatusCount = (params) => post(`vip/home/data/statusCount`, params)

/**
 * 今日发货量、本月发货量
 *
 * @param {*} params
 * @returns
 */
export const reqSendCount = (params) => post(`vip/home/data/sendCount`, params)

/**
 * 及时揽收统计

 *
 * @param {*} params
 * @returns
 */
export const reqTakeCount = (params) => post(`vip/home/data/takeCount`, params)

/**
 * 发货量走势图
 *
 * @param {*} params
 * @returns
 */
export const reqSendTrend = (params) => post(`vip/home/data/sendTrend`, params)

/**
 * 订单占比
 *
 * @param {*} params
 * @returns
 */
export const reqOrderRate = (params) => post(`vip/home/data/orderRate`, params)

/**
 * 问题件类型分布
 *
 * @param {*} params
 * @returns
 */
export const reqProblemCount = (params) => post(`vip/home/data/problemCount`, params)
